/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/getFeatureFlags1Overrides';
import type { GetFeatureFlags1QueryParams } from '../../operation-overrides/getFeatureFlags1Overrides';

export type GetFeatureFlags1PathParams = NonNullable<operations['getFeatureFlags1']['parameters']['path']>;
export type { GetFeatureFlags1QueryParams };

export interface Input extends GetFeatureFlags1PathParams {
  apiVersion?: string;
  query?: GetFeatureFlags1QueryParams;
}

export async function getFeatureFlags1(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/flags/{projectKey}', {
    params: {
      path,
      // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
      query,
    },
    // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
    querySerializer: overrides.querySerializer,
    headers: mergeHeaders(headers, { 'LD-API-Version': apiVersion ?? overrides.apiVersion }),
    signal,
  });
}
